import styled from "styled-components";

export const Content = styled.div`
  max-width: 1200px;
  display: flex;
  flex-direction: column;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-bottom: 24px;
`;

export const TicketList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
`;

export const TicketCard = styled.div`
  cursor: pointer;
  width: 380px;
  .ant-card-body {
    display: flex;
    background: #f9f9f9;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 15px 20px;
  }

  .ant-card-meta-description {
    display: -webkit-box;

    /* 2. Define a orientação do bloco */
    -webkit-box-orient: vertical;

    /* 3. Limita o número de linhas */
    -webkit-line-clamp: 2;

    /* 4. Esconde o que sobrar e adiciona o "..." */
    overflow: hidden;
    text-overflow: ellipsis;

    /* Opcional: Garante que palavras longas não quebrem o layout */
    word-break: break-word;
    margin-right: 10px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    font-size: 12px;
    color: #8c8c8c;
  }

  .ant-card-meta {
    margin-bottom: 16px;
  }

  .ticket-info {
    font-size: 12px;
    color: #8c8c8c;
    text-align: end;
    width: 100%;
  }
`;

export const TicketView = styled.div`
  background: #f9f9f9;
  padding: 16px;
  border-radius: 8px;
`;

export const TicketViewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  div {
    display: flex;
    flex-direction: row;
    margin-bottom: 15px;
    align-items: center;
  }

  h2 {
    font-size: 18px;
  }
  p {
    font-size: 13px;
  }
  .ticket-actions {
    margin-left: auto;
  }
`;

export const TicketViewBody = styled.div`
  .chat-window-body {
    overflow-y: auto;
    height: 400px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    margin-top: 16px;
    padding: 16px 16px;
    display: flex;
    flex-direction: column-reverse;
  }

  .message {
    display: flex;
    flex-direction: column;
  }

  .message-timestamp {
    font-size: 0.75rem;
    color: #65676b;
    margin-top: 4px;
  }

  .message-content {
    padding: 12px;
    border-radius: 18px;
    max-width: 80%;
    width: fit-content;
    flex-direction: column-reverse;
  }

  .message.sent {
    align-items: flex-end;
  }

  .message.sent .message-content {
    background-color: #008037;
    color: white;
  }

  .message.sent .message-timestamp {
    align-self: flex-end;
  }

  .message.received {
    align-items: flex-start;
  }

  .message.received .message-content {
    background-color: #f0f2f5;
    color: #050505;
  }

  .chat-footer {
    padding-top: 16px;
  }
`;

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1200px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .orders {
    width: 100%;
    overflow-x: auto;
  }

  .order {
    background-color: #f1f1f1;
    border: 1px solid #0000001c;
    padding: 15px;
    width: 1000px;
    display: flex;
    border-radius: 5px;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .title {
      margin-bottom: 7px;
      font-weight: 600;
      font-size: 14px;
      text-align: left;
      word-wrap: break-word;
      white-space: normal;
    }

    .back {
      display: inline-block;
      border-radius: 50px;
      padding: 6px 12px;
      background-color: #fff;
      text-overflow: ellipsis;
    }

    button {
      padding: 6px 15px;
      border-radius: 50px;
      font-size: 16px;
      margin-left: 50px;
      max-width: 150px;
      font-weight: 500;
      font-family: Montserrat;
      align-self: flex-end;
    }
  }
`;

export const CardCount = styled.div`
  border-radius: 8px;
  width: 165px;
  height: 45px;
  padding: 0 25px;
  border-radius: 50px;
  margin-bottom: 15px;
  background: #008037;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  font-family: Montserrat;
  color: #fff;
  font-weight: 600;
`;
